module.exports = __webpack_public_path__ + "media/pricing/Incident_Report-d51ff306.pdf";